import { FormScenario, FormShowAs } from 'src/models/form.model';

// new-ui
export const LOG_IN_FORM_SCENARIO: FormScenario = {
  _init: { noRequired: true, validationDebounceDelay: 0 },
  email: {
    autofocus: true,
    autoComplete: true,
    label: 'Email',
    showAs: FormShowAs.TEXT,
    isRequired: true,
    placeholder: 'Enter your email...',
    type: 'email',
  },
  password: {
    label: 'Password',
    showAs: FormShowAs.TEXT,
    isRequired: true,
    isSubmittable: true,
    placeholder: 'Enter your password...',
    type: 'password',
  },
};
